const enableMarketplaceMutation = `
  mutation EnableMarketplace($id: ID!, $fields: UpdateOrganizzazioneFieldsInput) {
    updateOrganizzazione(input: { id: $id, fields: $fields }) {
      organizzazione {
        objectId
        nome
        marketplace
      }
    }
  }
`
  .replace(/\r?\n|\r/g, "")
  .replace(/\t/g, " ");

export default enableMarketplaceMutation;
